import styled from 'styled-components';

export const LoginContainer = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
`;

export const LeftContainer = styled.div`
  display: flex;
  background: #fff;
  flex-basis: 50%;
  @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
    flex-basis: 100%;
    padding: 0 30px;
  }
`;

export const RightContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-basis: 50%;
  background: linear-gradient(109.4deg, #018EFF 1.26%, #00DA8B 96.4%);
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 500px;
  padding: 60px 0;
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    width: 100%;
  }
`;

export const Form = styled.form`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    width: 100%;
  }
  h1 {
    font-weight: 700;
    font-size: 35px;
    line-height: 42px;
    letter-spacing: 1px;
    color: ${({ theme }) => theme.accent};
    margin-bottom: 30px;
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.2px;
    color: ${({ theme }) => theme.gray};
    margin-bottom: 30px;
  }
  button {
    display: flex;
    justify-content: center;
    width: 255px;
    background: #ff4ea1;
    box-shadow: 0px 4px 12px rgba(55, 81, 255, 0.24);
    border-radius: 31px;
    padding: 15px 24px 13px;
    border: none;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: #ffffff;
    margin-top: 39px;
    margin-bottom: 33px;
    transition: all 300ms ease-in-out;
    :hover{
      box-shadow: 0px 6px 24px rgba(37, 61, 217, 0.32);
      background: ${({theme}) => theme.pinkLight};
    }
    :disabled{
      background: ${({theme}) => theme.pastelPink};
      :hover{
        cursor: default;
      }
    }
    @media (max-width: ${({theme}) => theme.breakpoints.md}) {
      width: 100%;
    }
  }
  
`;

export const AfterEmailSentContaier = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  h1 {
    font-weight: 700;
    font-size: 35px;
    line-height: 42px;
    letter-spacing: 1px;
    color: ${({ theme }) => theme.accent};
    margin-bottom: 30px;
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.2px;
    color: ${({ theme }) => theme.gray};
    margin-bottom: 30px;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const ErrorMessage = styled.span`
  margin-top: 16px;
  color: ${({ theme }) => theme.red};
`;
